import { Injectable, Inject } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { LoginService } from '../services/login.service';
import { isDevServer } from '../runtime-config';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    @Inject(LoginService) private loginService: LoginService,
    @Inject(Router) private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    // Wait for login check to complete
    return this.loginService.promise.then(() => {
      if (this.loginService.getLoginState().isLoggedIn) {
        if (route.data?.['patrikOnly'] && !this.loginService.arPatrik()) {
          return this.router.parseUrl('/time');
        }

        if (route.data?.['devServerOnly'] && !isDevServer()) {
          return this.router.parseUrl('/time');
        }

        return true;
      }

      // Redirect to login
      this.router.navigate(['/login']);
      return false;
    });
  }
}
